import { Bike, Package, Zap } from "lucide-react";

export interface BrandIconProps {
  brand: string;
  className?: string;
}

/**
 * Returns an icon representing the vehicle brand.
 * E-bike brands show a bike with a zap indicator.
 * Cargo brands show a bike with a package indicator.
 */
export function BrandIcon({
  brand,
  className = "tw-w-full tw-h-full",
}: BrandIconProps): JSX.Element {
  const upperBrand = brand.toUpperCase();

  if (upperBrand.includes("OMNI") || upperBrand.includes("SEG")) {
    return (
      <div className="tw-relative tw-w-full tw-h-full">
        <Bike className={className} />
        <Zap className="tw-absolute tw--top-0.5 tw--right-0.5 tw-w-2 tw-h-2 tw-text-amber-500 tw-fill-amber-500" />
      </div>
    );
  }

  if (upperBrand.includes("CARGO") || upperBrand.includes("BOX")) {
    return (
      <div className="tw-relative tw-w-full tw-h-full">
        <Bike className={className} />
        <Package className="tw-absolute tw--top-0.5 tw--right-0.5 tw-w-2 tw-h-2 tw-text-amber-700" />
      </div>
    );
  }

  return <Bike className={className} />;
}
